/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const QuizViewModesEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('QUIZ_VIEW_MODES_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class QuizViewModesEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return QuizViewModesEnabledSettingParser.decode(input).map(res => new QuizViewModesEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return QuizViewModesEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return QuizViewModesEnabledSettingParser.encode(data);
    }
    static schema() {
        return QuizViewModesEnabledSettingParser.schema();
    }
}
